import * as React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { ChevronDown } from 'lucide-react';

import Utils from '../../common/utils';
import { Button } from '../../components/buttons';
import { Icon } from 'src/components/icons/Icon';

interface IProps {
	className?: string;
	tabs: any[];
	toggleLabel?: string;
	location?: any;
	match?: any;
	disableDocTitle?: boolean;
	disabled?: boolean;
}

interface IState {
	isTabExpanded: boolean;
}

class Tabs extends React.Component<IProps, IState> {
	constructor(props: any) {
		super(props);
		this.state = {
			isTabExpanded: false
		};
	}

	public componentDidMount() {
		if (!this.props.disableDocTitle) {
			Utils.setDocTitle(this.getTabTitle());
		}
	}

	public componentDidUpdate(prevProps: IProps) {
		if (!this.props.disableDocTitle && prevProps.location !== this.props.location) {
			Utils.setDocTitle(this.getTabTitle());
		}
	}

	public onTabToggle = (state?: string) => {
		let isOpened = !this.state.isTabExpanded;
		switch (state) {
			case 'open':
				isOpened = true;
				break;
			case 'close':
				isOpened = false;
				break;
			default:
				break;
		}

		// Close the tab toggle if the user clicks anywhere
		if (isOpened) {
			document.body.addEventListener('click', () => this.onTabToggle('close'));
		} else {
			document.body.removeEventListener('click', () => this.onTabToggle('close'));
		}

		this.setState({ isTabExpanded: isOpened });
	}

	public render() {
		const { ...props } = this.props;
		return props.tabs.length > 0 ? (
			<div className={classNames('border-top border-bottom tab-wrapper', props.className)}>
				<Button className={`d-none tab-toggler${this.state.isTabExpanded ? ' active' : ''}`} onClick={this.onTabToggle}>
					<span className="tab-toggler-label align-middle">
						{this.getTabTitle('Select a page...')}
					</span>
					<Icon icon={ChevronDown} className="tab-toggler-icon" />
				</Button>
				<div className={`tab-collapse${this.state.isTabExpanded ? '' : ' collapsed'}`}>
					{props.tabs.map((tab) => {
						if (props.disabled === true) {
							if (tab.to === window.location.pathname) {
								return <div className={`btn tab active`}>
									{tab.label}
								</div>
							}
							else {
								return <div className={`btn tab disabled`}>
									{tab.label}
								</div>
							}
						}
						else {
							// TODO: Determine if exact for the active check is viable
							return <NavLink className={`btn tab`} to={tab.to} key={tab.id || tab.to} exact={true}>
								{tab.label}
							</NavLink>
						}
					})}
				</div>
			</div>
		) : null;
	}

	private getTabTitle = (defaultTitle: string = '') => {
		let title = defaultTitle;

		const currentTab = this.props.tabs.find((tab: any) => {
			return this.props.location && (tab.to === this.props.location.pathname);
		});

		if (currentTab) {
			title = currentTab.label;
		}

		return title;
	}
}

export default Tabs;
